import { render, staticRenderFns } from "./ItemHistoryChangeTypeRelationshipOneToMany.vue?vue&type=template&id=12299581&scoped=true"
import script from "./ItemHistoryChangeTypeRelationshipOneToMany.vue?vue&type=script&lang=js"
export * from "./ItemHistoryChangeTypeRelationshipOneToMany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12299581",
  null
  
)

export default component.exports